module.exports = __webpack_public_path__ + "static/mhotspot-awards-4194502f879e2a767f3f69323eb09201.jpg";